import React from "react";
import StaffLogin from "./StaffLogin";

export default function LogisticsLogin() {
  return (
    <StaffLogin
      role="logistics"
      storageKey="logisticsStaff"
      dashboardPath="/logistics-dashboard"
      badge="LOGISTICS ACCESS"
      title="Proove Logistics"
    />
  );
}
